import React from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import TelegramIcon from "@mui/icons-material/Telegram";
import { demoUser } from "../utils/StringUtils";
import { BRAND_NAME } from "../constants/Branding";

interface EmptyUserIdPopupProps {
  open: boolean;
  onClose: () => void;
  linkUrl?: string;
}

const EmptyUserIdPopup: React.FC<EmptyUserIdPopupProps> = ({ open, onClose, linkUrl }) => {
  if (demoUser()) {
    return null;
  }

  const handleClose = () => {
    sessionStorage.setItem("emptyUserIdAlertDismissed", "true");
    onClose();
  };

  const handlePrimaryClick = () => {
    const trimmedUrl = (linkUrl || "").trim();
    if (trimmedUrl) {
      window.open(trimmedUrl, "_blank", "noopener,noreferrer");
    }
    handleClose();
  };

  const isKhelo365days = BRAND_NAME === 'Khelo365days';

  return !isKhelo365days ? (
    <Dialog
      fullScreen={false}
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          position: "absolute",
          top: "5rem",
        },
      }}
    >
      <div className="empty-user-id-popup bg-inputbox-color relative p-4">
        <CloseIcon
          className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
          onClick={handleClose}
        />
        <div className="text-white">
          <div className="flex justify-center mb-4">
            <TelegramIcon
              style={{
                fontSize: "50px",
                color: "var(--border-color)",
                paddingTop: "0px",
              }}
            />
          </div>
          <h2 className="text-lg font-semibold mb-2 text-center">Tired of logging in every time?</h2>
          <p className="text-base mb-2 text-center opacity-90">
            Connect your account once and start logging in faster with Telegram.
          </p>
          <p className="text-base font-semibold mb-4 text-center" style={{ color: "var(--border-color)" }}>
            Tap below to enable secure, passwordless login.
          </p>
          <div className="flex justify-center">
            <button
              type="button"
              className="p-2.5 px-8 text-sm sm:text-base text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem] min-w-[120px] sm:min-w-[150px]"
              onClick={handlePrimaryClick}
            >
              Enable Passwordless Login
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  ) : null;
};

export default EmptyUserIdPopup;
